import React from 'react';

import Button from '@dashboard/components/Button';
import useViewAsMerchant from '@dashboard/admin/hooks/useViewAsMerchant';

export default function ViewAsMerchantButton({ sellerId, path, children }) {
  const viewAsMerchant = useViewAsMerchant();

  return (
    <Button
      appearance="light"
      size="small"
      onClick={() => viewAsMerchant(sellerId, path)}
      disabled={!sellerId}
    >
      {children}
    </Button>
  );
}
